import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material después de comprar?',
  a: 'Recibirás el acceso de forma inmediata por correo electrónico. No hay esperas ni trámites adicionales.'
}, {
  q: '¿Es físico o digital?',
  a: 'Es un producto 100% digital en formato PDF. Podés descargarlo, guardarlo y usarlo desde cualquier dispositivo.'
}, {
  q: '¿Puedo imprimirlo?',
  a: 'Sí. El formato PDF está optimizado para impresión si preferís trabajar con el material en papel.'
}, {
  q: '¿El material es editable?',
  a: 'El material se entrega en formato PDF y no incluye archivos editables. Está diseñado para usarse directamente tal como está.'
}, {
  q: '¿Para qué nivel educativo está pensado?',
  a: 'Principalmente para secundaria técnica y formación profesional con orientación en industrialización o tecnología de alimentos.'
}, {
  q: '¿Sirve para cualquier país de América Latina?',
  a: 'Los principios técnicos son aplicables en toda la región hispanohablante. Las normativas sanitarias y de rotulado varían por país y deben verificarse localmente.'
}, {
  q: '¿En qué moneda voy a pagar?',
  a: 'Podés pagar en tu moneda local. El sistema detecta automáticamente tu país y adapta el importe.'
}, {
  q: '¿Qué diferencia hay entre las dos opciones?',
  a: 'La opción de USD 19,90 incluye el sistema completo con 5 tomos y 4 recursos. Es completa y suficiente para todo el año. La opción de USD 27,90 agrega tres tomos avanzados con mayor profundidad técnica en conservas, cárnicos y lácteos premium. Por USD 8 adicionales, es la opción más completa disponible.'
}, {
  q: '¿Cómo funciona la garantía?',
  a: 'Tenés 7 días desde la compra para revisar todo el material. Si no cumple con lo prometido, contactanos y te devolvemos el 100% sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-cream-light border-t border-cream-dark" data-id="element-140">
      <div className="max-w-3xl mx-auto" data-id="element-141">
        <div className="text-center mb-16" data-id="element-142">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-green" data-id="element-143">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-144">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-cream-dark rounded-xl overflow-hidden shadow-sm" data-id="element-145">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-146">
                <span className="font-bold text-green pr-8" data-id="element-147">{faq.q}</span>
                <ChevronDown className={`text-terracota transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-148" />
              </button>

              <AnimatePresence data-id="element-149">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-150">
                    <div className="px-6 pb-5 text-ink border-t border-cream-dark/50 pt-4 text-sm leading-relaxed" data-id="element-151">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}